import { T } from "../themes";
import { clamp, hourOf } from "../constants";

export default function BurnDownChart({ logs, targetCalories }) {
  const W=414,H=160,PAD={top:14,right:14,bottom:30,left:44};
  const cW=W-PAD.left-PAD.right, cH=H-PAD.top-PAD.bottom;
  const S=8,E=22;
  const xS=t=>PAD.left+((t-S)/(E-S))*cW;
  const safeTarget=targetCalories>0?targetCalories:2000;
  const yS=v=>PAD.top+(1-clamp(v/safeTarget,0,1.25))*cH;

  const sorted=[...logs]
    .map(l=>{let ts=Date.now();try{if(l.logged_at)ts=new Date(l.logged_at).getTime();}catch(_){}return{ts,cal:parseFloat(l.calories)||0};})
    .filter(l=>{const h=hourOf(l.ts);return h>=S&&h<=E;})
    .sort((a,b)=>a.ts-b.ts);

  const totalConsumed=logs.reduce((s,l)=>s+(parseFloat(l.calories)||0),0);
  const displayRem=safeTarget-totalConsumed;
  const overBudget=displayRem<0;

  let pathRem=safeTarget;
  const pts=[{h:S,rem:pathRem}];
  sorted.forEach(e=>{
    const h=hourOf(e.ts)+new Date(e.ts).getMinutes()/60;
    if(h>=S&&h<=E){pathRem-=e.cal;pts.push({h:clamp(h,S,E),rem:pathRem});}
  });
  const nowH=clamp(new Date().getHours()+new Date().getMinutes()/60,S,E);
  pts.push({h:nowH,rem:displayRem});

  const pathD=pts.map((p,i)=>`${i===0?"M":"L"}${xS(p.h).toFixed(1)},${yS(p.rem).toFixed(1)}`).join(" ");
  const xTicks=[8,10,12,14,16,18,20,22];
  const yTicks=[0,0.25,0.5,0.75,1].map(f=>Math.round(safeTarget*f));

  return (
    <svg width="100%" viewBox={`0 0 ${W} ${H}`} style={{display:"block",overflow:"visible"}}>
      {yTicks.map(v=>(
        <g key={v}>
          <line x1={PAD.left} y1={yS(v)} x2={W-PAD.right} y2={yS(v)} stroke={T.cardBorder} strokeWidth={1} strokeDasharray="3,4"/>
          <text x={PAD.left-5} y={yS(v)+4} textAnchor="end" fill={T.inkFaint} fontSize={9} fontFamily={T.fontSans}>{v}</text>
        </g>
      ))}
      {xTicks.map(h=>(
        <text key={h} x={xS(h)} y={H-PAD.bottom+14} textAnchor="middle" fill={T.inkFaint} fontSize={8} fontFamily={T.fontSans}>{h}h</text>
      ))}
      <line x1={PAD.left} y1={yS(safeTarget)} x2={W-PAD.right} y2={yS(safeTarget)} stroke={T.accent} strokeWidth={1} strokeDasharray="6,4" opacity={0.4}/>
      <line x1={PAD.left} y1={yS(0)} x2={W-PAD.right} y2={yS(0)} stroke={T.cardBorder} strokeWidth={1.5}/>
      {pts.length>1&&<path d={pathD} fill="none" stroke={overBudget?T.red:T.accent} strokeWidth={2.5} strokeLinejoin="round"/>}
      {pts.length>0&&(()=>{const l=pts[pts.length-1];return<circle cx={xS(l.h)} cy={yS(l.rem)} r={5} fill={overBudget?T.red:T.actionPrimary} stroke={T.card} strokeWidth={2}/>;})()}
      {(()=>{
        const _rawH=new Date().getHours()+new Date().getMinutes()/60;
        if(_rawH>=E||totalConsumed===0)return null;
        const _elapsed=Math.max(0.1,_rawH-7);
        const _hoursLeft=Math.max(0,E-_rawH);
        const _burnRate=totalConsumed/_elapsed;
        const _projEnd=Math.max(0,displayRem-(_burnRate*_hoursLeft));
        const _x1=xS(nowH).toFixed(1);
        const _y1=yS(displayRem).toFixed(1);
        const _x2=xS(E).toFixed(1);
        const _y2=yS(_projEnd).toFixed(1);
        return(
          <>
            <line x1={_x1} y1={_y1} x2={_x2} y2={_y2} stroke={T.inkFaint} strokeWidth={1.5} strokeDasharray="4,4" opacity={0.6}/>
            <text x={_x2} y={Number(_y2)-6} textAnchor="end" fill={T.inkFaint} fontSize={8} fontFamily={T.fontSans} opacity={0.6}>~{Math.round(_projEnd)}</text>
          </>
        );
      })()}
    </svg>
  );
}
